import * as React from 'react'

function SvgNavTransactions(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.059 15c0-5.49 4.45-9.94 9.94-9.94 5.49 0 9.94 4.45 9.94 9.94 0 5.49-4.45 9.94-9.94 9.94a9.896 9.896 0 01-6.5-2.418 1.5 1.5 0 00-1.962 2.269A12.896 12.896 0 0015 27.94c7.146 0 12.94-5.794 12.94-12.94 0-7.148-5.794-12.94-12.94-12.94-7.147 0-12.94 5.792-12.94 12.94 0 1.044.308 2.577.465 3.303a1.5 1.5 0 002.235.972l4.008-2.391a1.5 1.5 0 00-1.537-2.577l-2.134 1.274A5.592 5.592 0 015.06 15zm11.44-5.5a1.5 1.5 0 00-3 0v6.121l3.939 3.94a1.5 1.5 0 002.121-2.122l-3.06-3.06V9.5z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgNavTransactions
